
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade-contract",
      function () {
        return require("private-next-pages/trade-contract.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade-contract"])
      });
    }
  